import pug from 'javascripts/core_post_webpack/sitewide_business_elements/navbar/templates/view_all_button.jst.pug';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/navbar/templates/view_all_button'
] = pug;
